module.exports = __webpack_public_path__ + "img/login-paint@2x.70798e0f.png";